import { useNavigate } from "react-router";
import { Button } from "../ui/button";
import { ArrowLeft } from "lucide-react";

function NoAuthorized() {
  const navigate = useNavigate();

  return (
    <div className="h-full flex flex-col items-center justify-center p-4">
      <div className="text-center flex flex-col gap-2 justify-center items-center">
        <h1 className="text-xl font-bold">No autorizado 😰</h1>
        <p className="text-md text-muted-foreground">
          No tienes permiso para acceder a esta página.
        </p>
        <Button
          onClick={() => navigate("/")}
          variant="secondary"
          className="w-fit"
        >
          <ArrowLeft />
          Volver al inicio
        </Button>
      </div>
    </div>
  );
}

export default NoAuthorized;
